var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-card',{staticClass:"roundedCard",attrs:{"flat":""}},[(_vm.title)?_c('v-card-title',{staticClass:"font-weight-light text-h6 pb-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{staticClass:"px-2"},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }